import { t } from "ttag";

import { getGenderLabel } from "@/shared/models";
import type { Patient } from "@/shared/models/legacy-types";
import { CalendarMinimalisticIcon, GenderIcon, UserIcon } from "@/shared/ui";
import { formatBackendDate } from "@/shared/utils";
import { ProfileCard } from "../components";

interface GeneralInformationProps {
  patient: Patient;
}

export const GeneralInformation = ({ patient }: GeneralInformationProps) => (
  <ProfileCard.Root color="secondary">
    <ProfileCard.Header>
      <ProfileCard.Title>{t`General information`}</ProfileCard.Title>
    </ProfileCard.Header>

    <div className="flex flex-col gap-4">
      <ProfileCard.Item>
        <ProfileCard.ItemLabel>
          <UserIcon className="size-4" />
          {t`First name`}
        </ProfileCard.ItemLabel>
        <ProfileCard.ItemValue>{patient.firstName}</ProfileCard.ItemValue>
      </ProfileCard.Item>

      <ProfileCard.Item>
        <ProfileCard.ItemLabel>
          <UserIcon className="size-4" />
          {t`Last name`}
        </ProfileCard.ItemLabel>
        <ProfileCard.ItemValue>{patient.lastName}</ProfileCard.ItemValue>
      </ProfileCard.Item>

      <ProfileCard.Item>
        <ProfileCard.ItemLabel>
          <GenderIcon className="size-4" />
          {t`Sex assigned at birth`}
        </ProfileCard.ItemLabel>
        <ProfileCard.ItemValue>
          {patient.gender ? getGenderLabel(patient.gender) : "-"}
        </ProfileCard.ItemValue>
      </ProfileCard.Item>

      <ProfileCard.Item>
        <ProfileCard.ItemLabel>
          <CalendarMinimalisticIcon className="size-4" />
          {t`Date of birth`}
        </ProfileCard.ItemLabel>
        <ProfileCard.ItemValue>
          {formatBackendDate(patient.dateOfBirth)}
        </ProfileCard.ItemValue>
      </ProfileCard.Item>
    </div>
  </ProfileCard.Root>
);
